(function () {
  function attachPrice(btn) {
    var card = btn.closest('.resource-list__item');
    if (!card) return;

    var priceEl = card.querySelector('product-price .price');
    if (!priceEl) return;

    var priceText = priceEl.textContent.trim();
    if (!priceText) return;

    var existing = btn.querySelector('.mct-btn-price');
    if (existing) {
      if (existing.textContent !== ' - ' + priceText) {
        existing.textContent = ' - ' + priceText;
      }
      return;
    }

    var addedSpan = btn.querySelector('.add-to-cart__added');
    var priceSpan = document.createElement('span');
    priceSpan.className = 'mct-btn-price';
    priceSpan.textContent = ' - ' + priceText;

    if (addedSpan) {
      btn.insertBefore(priceSpan, addedSpan);
    } else {
      btn.appendChild(priceSpan);
    }
  }

  function addPriceToButtons(root) {
    root.querySelectorAll('.add-to-cart-button').forEach(attachPrice);
  }

  function watchForButtons(root) {
    addPriceToButtons(root);

    var observer = new MutationObserver(function () {
      addPriceToButtons(root);
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Safety net: covers any timing edge case where the observer
    // fires before the price web component finishes hydrating.
    var attempts = 0;
    var interval = setInterval(function () {
      addPriceToButtons(root);
      attempts++;
      if (attempts >= 10) clearInterval(interval);
    }, 500);
  }

  function initMCT(root) {
    var tabs = root.querySelectorAll('[data-mct-tab]');
    var panels = root.querySelectorAll('[data-mct-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-mct-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          var isMatch = p.getAttribute('data-mct-panel') === key;
          p.classList.toggle('is-active', isMatch);
          if (isMatch) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });

        window.dispatchEvent(new Event('resize'));
      });
    });

    watchForButtons(root);
  }

  document.querySelectorAll('[data-mct]').forEach(initMCT);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mct]');
    if (root) initMCT(root);
  });
})();